import axios from '../axios';

export function encyclopediaClassesList(params) {
  return axios.get('hs_encyclopedia/1.0/encyclopedia_classes_list', params);
}
